import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { UserLike } from '../../../services/avatar.service';
import { AvatarComponent } from '../../../shared/components/avatar/avatar.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { CapitalizePipe } from '../../../shared/pipes/capitalize.pipe';

@Component({
  selector: 'app-access-item',
  imports: [SvgComponent, AvatarComponent, CapitalizePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './access-item.component.html',
  styleUrl: './access-item.component.scss',
})
export class AccessItemComponent {
  icon = input<string>();
  iconColor = input<string>();
  avatarUser = input<UserLike>();
  pendingLetter = input<string>();
  hideOverflow = input<boolean>();
  small = input<boolean>();
}
